module.exports = __webpack_public_path__ + "img/1_4@2x.8ec67f9b.png";